export const SHARE_LINK_CONSTANTS = {
  // URL Templates
  OUTLOOK_WEB_URL: "https://outlook.office.com/mail/deeplink/compose",
  TEAMS_SHARE_URL: "https://teams.microsoft.com/share",

  // Email Templates
  EMAIL_SUBJECT_TEMPLATE: (entityName: string) => `${entityName} - Security 360`,
  EMAIL_BODY_TEMPLATE: (entityName: string, url: string) => `Check out ${entityName} details:\n\n${url}`,
  TEAMS_MESSAGE_TEMPLATE: (entityName: string, url: string) => `Check out ${entityName} details: ${url}`,

  // Window Options
  WINDOW_OPTIONS: {
    SECURE: "noopener,noreferrer",
    TARGET_BLANK: "_blank"
  },

  // Menu Item Keys
  MENU_ITEMS: {
    COPY_LINK: "copyLink",
    DIVIDER: "divider1",
    OUTLOOK_WEB: "outlookWeb",
    OUTLOOK_DESKTOP: "outlook",
    TEAMS: "teams"
  },

  // Menu Item Texts
  MENU_TEXTS: {
    COPY_LINK: "Copy Link",
    OUTLOOK_WEB: "Outlook Web",
    OUTLOOK_DESKTOP: "Outlook Desktop",
    TEAMS: "Microsoft Teams",
    DIVIDER: "-"
  },

  // Menu Item Titles (Tooltips)
  MENU_TITLES: {
    COPY_LINK: "Copy the page URL to clipboard",
    OUTLOOK_WEB: "Share via Outlook Web App",
    OUTLOOK_DESKTOP: "Share via Outlook desktop app",
    TEAMS: "Share to Microsoft Teams",
    SHARE_BUTTON: "Share link with current filters applied"
  },

  // Icons
  ICONS: {
    COPY: "Link",
    OUTLOOK_LOGO: "OutlookLogo",
    MAIL: "Mail",
    TEAMS_LOGO: "TeamsLogo",
    SHARE: "Share"
  },

  // Event Names
  EVENTS: {
    COPY_LINK: "CopyLink",
    SHARE_OUTLOOK_WEB: "ShareOutlookWeb",
    SHARE_OUTLOOK: "ShareOutlook",
    SHARE_TEAMS: "ShareTeams"
  },

  // Event Categories
  EVENT_CATEGORIES: {
    COPY_LINK: (pageType: string) => `${pageType} Copy Link`,
    SHARE_OUTLOOK_WEB: (pageType: string) => `${pageType} Share Outlook Web`,
    SHARE_OUTLOOK: (pageType: string) => `${pageType} Share Outlook`,
    SHARE_TEAMS: (pageType: string) => `${pageType} Share Teams`,
    PAGE: (pageType: string) => `${pageType} Page`
  },

  // Error Messages
  ERROR_CATEGORIES: {
    COPY_URL: "Copy URL",
    SHARE_OUTLOOK_WEB: "Share Outlook Web",
    SHARE_OUTLOOK: "Share Outlook",
    SHARE_TEAMS: "Share Teams"
  },

  // Styles
  STYLES: {
    ROOT_MIN_WIDTH: "200px",
    FONT_SIZE: "14px",
    BORDER_RADIUS: "4px"
  },

  // Context Menu Item Types
  ITEM_TYPES: {
    DIVIDER: 1 // ContextualMenuItemType.Divider
  }
} as const;
